module.exports = "<div class=\"input-color-wrapper\"><div class=\"input input_nano input_color ms-input_border\" minicolors=\"{opacity: true}\" ng-model=\"widget.modules_settings.style.borderColor\"></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./~/pug-html-loader/lib!./src/app/editor/modules_settings/strokecolor/template.jade
// module id = 359
// module chunks = 0